<form (submit)="onSave()" #f="ngForm">
  <div class="container-fluid p-0">
    <div class="px-3 py-4">

      <div class="row mb-4">
        <div class="col">
          <div *ngIf="assignee.id">
            <h6>Investigator</h6>
            <p>{{ assignee.contact_person }}</p>
          </div>

          <div *ngIf="reviewer.id">
            <h6>Reviewer</h6>
            <p>{{ reviewer.contact_person }}</p>
          </div>

          <button
            type="button"
            mat-raised-button
            color="secondary"
            (click)="onSelectInvestigator()"
            [matBadge]="'' + (assignee.id ? 1 : 0)"
            class="my-2 ml-1 mr-2"
            matTooltip="An assignee is required for an investigation to begin">
            <mat-icon>person</mat-icon>
            {{ !assignee.id ? 'Select' : 'Change' }} Investigator
          </button>

          <button
            type="button"
            mat-raised-button
            color="secondary"
            (click)="onSelectReviewer()"
            [matBadge]="'' + (reviewer.id ? 1 : 0)"
            class="my-2 ml-1 mr-2"
            matTooltip="You can optionally select a reviewer.">
            <mat-icon>rate_review</mat-icon>
            {{ !reviewer.id ? 'Select' : 'Change' }} Reviewer
          </button>
        </div>
      </div>

      <h6>What happened before the incident?</h6>
      <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
        <textarea [(ngModel)]="incident.before_incident_notes" matInput
          name="before-incident-notes" cols="30" rows="5"></textarea>
      </mat-form-field>

      <h6>How did the incident occur?</h6>
      <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
        <textarea [(ngModel)]="incident.incident_notes" name="incident-notes"
          matInput cols="30" rows="5"></textarea>
      </mat-form-field>

      <h6>What happened after the incident?</h6>
      <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
        <textarea [(ngModel)]="incident.after_incident_notes" matInput
          name="after-incident-notes" cols="30" rows="5"></textarea>
      </mat-form-field>

    </div>
  </div>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">
    <button
      mat-raised-button
      color="primary"
      type="submit"
      class="my-2 ml-1 mr-2"
      matTooltip="Save the risk assessments"
      [disabled]="!f.valid || inProgress">
      <mat-icon>save</mat-icon>
      Save
    </button>
  </mat-dialog-actions>
</form>
